// extracted by mini-css-extract-plugin
export default {"slide":"Slide-styles__slide__D6dnk","title":"Slide-styles__title__jEImv"};